import React, { useState, useEffect, useContext } from 'react';
import { Tab, TabProps, Dimmer, Loader, Button, Icon } from 'semantic-ui-react';

import * as User from '../../../services/User';

import './style.less';
import ConnectedResident from '../../components/connectedResident';
import UserContext from '../../../contexts/UserContext';
import RedirectContext from '../../../contexts/RedirectContext';
import './style.less';
import { linkAlexaFromAlexaApp } from '../../../services/sso';
import queryString from 'query-string';

const LinkResidentList = (props) => {
    const [loading, setLoading] = useState<boolean>(false);
    const [redirectUri,setRedirectUri] = useState<string>('');
    const [redirectState, setRedirectState] = useState('');
    const [loadingBtn, setLoadingBtn] = useState(false)
    const {
        userObject: {
            registrants: { list: listOfResidents },
        },
    } = useContext(UserContext);


    useEffect(() => {
        const { redirect_uri,state } = queryString.parse(props.location.search);
        if (redirect_uri && typeof(redirect_uri) === 'string' && typeof(state) === 'string') {
            setRedirectUri(redirect_uri);
            setRedirectState(state);
        }

    }, [props.location.search]);


    const linkAlexa = async id => {
        console.log('id', id);
        setLoadingBtn(true);
        const {authCode} = await linkAlexaFromAlexaApp(id);
        setLoadingBtn(false);

        console.log(redirectUri)
        if (redirectUri) {
            const redirectUrl = `${redirectUri}?code=${authCode}&state=${redirectState}`;
            console.log(redirectUrl);
            window.location.href = redirectUrl;

        }
    }


    const toggleRedirect = useContext(RedirectContext);

    return (
        <div className="relative-list link-resident-list">
            <Dimmer active={loading} inverted>
                <Loader active={loading} />
            </Dimmer>
            {listOfResidents.filter(({manager, isCommunityManager}) => manager || isCommunityManager ).map((resident) => {
                const { FirstName, LastName, Image, _id } = resident;
                return (
                    <div className="resident-list-item" key={resident._id}>
                        <div>
                            <div className={`resident-image-container`}>
                                {Image ? (
                                    <div
                                        className="resident-image resident-image-bk"
                                        style={{
                                            background: `url(${Image}) no-repeat`,
                                            backgroundPosition: 'center',
                                        }}
                                    />
                                ) : (
                                    <div className="relative-avatar">
                                        {FirstName.charAt(0)}
                                        {LastName.charAt(0)}
                                    </div>
                                )}
                            </div>
                        </div>
                        <div className="name-section">{`${FirstName} ${LastName}`}</div>
                        <div className="button-section">
                            <Button size="tiny" primary loading={loadingBtn} onClick={() => {
                                linkAlexa(_id)
                            }}>
                                Link
                            </Button>
                        </div>
                    </div>
                );
            })}
            {/* <div className="add-user-section">
                <Button basic color="blue" large>
                    <Icon name="add circle"></Icon> Add Alexa User
                </Button>
            </div> */}
        </div>
    );
};

export default LinkResidentList;
